"use client";

import { useEffect, useState } from "react";

const FONT_SIZES = [14, 16, 18, 20];
const LS_FONT = "nsl-font-size";
const LS_THEME = "nsl-theme";

export function ReadingToolbar() {
  const [dark, setDark] = useState(false);
  const [fontIdx, setFontIdx] = useState(1); // default index → 16 px

  useEffect(() => {
    // Font size
    const savedFont = localStorage.getItem(LS_FONT);
    if (savedFont) {
      const idx = FONT_SIZES.indexOf(Number(savedFont));
      if (idx !== -1) {
        setFontIdx(idx);
        document.documentElement.style.fontSize = `${FONT_SIZES[idx]}px`;
      }
    }
    // Theme — read current class (already set by inline script in <head>)
    setDark(document.documentElement.classList.contains("dark"));
  }, []);

  function toggleDark() {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem(LS_THEME, next ? "dark" : "light");
  }

  function changeFont(delta: number) {
    const next = Math.max(0, Math.min(FONT_SIZES.length - 1, fontIdx + delta));
    setFontIdx(next);
    document.documentElement.style.fontSize = `${FONT_SIZES[next]}px`;
    localStorage.setItem(LS_FONT, String(FONT_SIZES[next]));
  }

  return (
    <div className="flex items-center gap-0.5 ml-auto">
      <button
        onClick={() => changeFont(-1)}
        disabled={fontIdx === 0}
        // Mobile: min 44px tap target; Desktop: original compact size
        className="text-xs text-muted-foreground hover:text-foreground rounded hover:bg-accent transition-colors disabled:opacity-30 disabled:cursor-not-allowed px-3 min-h-[44px] md:px-2 md:min-h-0 md:py-1"
        aria-label="减小字号"
      >
        A-
      </button>
      <button
        onClick={() => changeFont(1)}
        disabled={fontIdx === FONT_SIZES.length - 1}
        className="text-sm font-medium text-muted-foreground hover:text-foreground rounded hover:bg-accent transition-colors disabled:opacity-30 disabled:cursor-not-allowed px-3 min-h-[44px] md:px-2 md:min-h-0 md:py-1"
        aria-label="增大字号"
      >
        A+
      </button>
      <button
        onClick={toggleDark}
        className="text-base text-muted-foreground hover:text-foreground rounded hover:bg-accent transition-colors px-3 min-h-[44px] md:px-2 md:min-h-0 md:py-1"
        aria-label={dark ? "切换浅色模式" : "切换深色模式"}
      >
        {dark ? "☀" : "☾"}
      </button>
    </div>
  );
}
